import { selectCurrentUser } from '@/models/account';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../ui/modals/Modal';
import { IModalTypes } from '../ui/modals/Modal/types';
import Text, {
  ITextColors,
  ITextStyles,
  ITextSizes,
} from '@/components/ui/content/Text';
import styles from './styles.module.scss';
import { AlertCircle } from 'react-feather';
import { getCssVar } from '@/utils/cssVars';
import { IContentColors } from '@/types';
import LoggedDevices from './LoggedDevices';
import { useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { timeLog } from 'console';
import ReactTooltip from 'react-tooltip';

const LoginLimit = ({ handleJoin, isLogoutMsg }) => {
  const currentUser = useSelector(selectCurrentUser) as any;
  const dispatch = useDispatch();
  const { eventId = '' } = useParams<{ eventId: string }>();
  const [isJoinActive, setIsJoinActive] = useState(false);
  const [isDescriptionHidden, setIsDescriptionHidden] = useState(false);

  const handleCancel = () => {
    dispatch({
      type: 'account/logout',
      payload: { eventId },
    });
  };

  const handleUpdate = loggedSessionCount => {
    if (loggedSessionCount == 0) {
      setIsDescriptionHidden(true);
    }
    setIsJoinActive(true);
  };

  function getTitleText() {
    const title = isLogoutMsg
      ? "You've been logged out"
      : (isJoinActive
      ? "You can join now"
      : "You're using too many devices");
    return title;
  }

  function getDescriptionText() {
    const descriptionText =
      isLogoutMsg ?
        "You joined event from too many devices and reached the limit": 
      (isJoinActive
        ? "Here are the devices you're currently using"
        : "You can join from here, but you'll be logged out from one of these devices:");

    return descriptionText;
  }

  return (
    <Modal
      styleClass={IModalTypes.LOGIN_LIMIT}
      autoTrigger={true}
      className={styles.limitModel}
      noHeader={true}
      render={({ setShow }) => (
        <div className={styles.container}>
          <div className={styles.alertCircleWrapper}>
            <AlertCircle
              size="20px"
              color={getCssVar(IContentColors.WHITE)}
              className={styles.alertCircle}
            />
          </div>
          <Text
            text={getTitleText()}
            className={styles.titleText}
            textLineHeight="32px"
            block={true}
          />
          {!isDescriptionHidden && (
            <Text
              text={getDescriptionText()}
              textLineHeight="26px"
              className={styles.descriptionText}
              block={true}
            />
          )}
          {!isLogoutMsg && <LoggedDevices handleUpdateDevice={handleUpdate} />}
          <div className={styles.button}>
            {!isLogoutMsg && (
              <button
                className={styles.cancelButton}
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
            )}
            {isLogoutMsg ? (
              <button
                className={styles.joinButtonInActive}
                onClick={handleCancel}
              >
                Ok
              </button>
            ) : isJoinActive ? (
              <button className={styles.joinButtonActive} onClick={handleJoin}>
                Join Now
              </button>
            ) : (
              <button
                className={styles.joinButtonInActive}
                onClick={handleJoin}
                data-tip
                data-for={'join-label'}
              >
                Join Now
              </button>
            )}
            {!isJoinActive && <ReactTooltip
                id="join-label"
                place="top"
                className={styles.tooltipText}
                effect="solid"
              >
                Please remove a device to join here
              </ReactTooltip>
            }
          </div>
        </div>
      )}
    />
  );
};

export default React.memo(LoginLimit);
